import BaseModel from './BaseModel';
import InspectionItem from './InspectionItem'

class VehicleInspectionItem extends BaseModel {
  constructor(data = {}, key) {
    super(data);
    this.updateData(data);
  }

  updateData = (data) => {
    this.vehicle_type_id = data.vehicle_type_id
    this.inspection_items = data.inspection_items.map((item, index)=> {
      return new InspectionItem({ ...item, index: index })
    })
  }

  validations = (field) => {
    return {
      vehicle_type_id: () => {
        if (this[field] === "") {
          this.errors.name = "Vehicle Type must exist";
        } else{
          delete this.errors.name;
        }
      },
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default VehicleInspectionItem;
